import { autoinject, bindable } from 'aurelia-framework';
import { debounce } from 'lodash';

@autoinject
export class AutoheightCard {
	@bindable cardHeader: string;
	private heightForFooter: number = 60;

	cardInner: HTMLElement;
	private onResize = debounce(this.syncHeight.bind(this), 200);

	syncHeight() {
		const html = document.documentElement;
		this.cardInner.style.height = `${html.clientHeight - this.cardInner.getBoundingClientRect().top - this.heightForFooter - 1}px`;
	}

	attached() {
		setTimeout(() => this.syncHeight(), 50); // Needed e.g. when moving from report view to report edit
		window.addEventListener('resize', this.onResize, true);
	}

	detached() {
		window.removeEventListener('resize', this.onResize, true);
	}
}
